import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'xlog-oauth-connect',
    templateUrl: './oauth-connect.component.pug',
    styleUrls: ['./oauth-connect.component.scss'],
    standalone: false
})
export class OauthConnectComponent implements OnInit {
    @Input() show: boolean;
    @Input() showLogout = true;
    @Input() showLogos = true;
    @Input() partnerName = '';
    @Input() partnerLogo = '/images/partner-logo-bg@2x.png';

    @Output() connectClicked = new EventEmitter();
    @Output() logoutClicked = new EventEmitter();

    constructor() {}

    ngOnInit() {}

    handleConnectClick() {
        this.connectClicked.emit();
    }

    handleLogoutClick() {
        this.logoutClicked.emit();
    }
}
